import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import { Accordion } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Content from 'common/page/Content';
import { REACT_APP_STRIPE_PK } from 'constants/env';

const stripePromise = REACT_APP_STRIPE_PK ? loadStripe(REACT_APP_STRIPE_PK) : null;

const ElementsProvider= (params) => {
  const { t } = useTranslation("billing");
  const options = {
    clientSecret: params.setup
  };

  return (
    <>
    <Accordion style={{paddingTop: "20px"}}>
      <Content>
      <h3 style={{paddingBottom: "20px"}}>{t("updateCard")}</h3>
    {!stripePromise &&
      <p>{t("missingPublishableKey")}</p>
    }
    {stripePromise && params.setup &&
    <Elements key={params.setup} stripe={stripePromise} options={options}>
        <CheckoutForm />
    </Elements>
    }
    </Content>
    </Accordion>
    </>
  );
};

export default ElementsProvider;
